/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Hands4(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Hands4.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Hands4.geometry}
        material={materials.Blue}
        position={[0.15, 188.51, 0]}
      >
        <meshPhysicalMaterial
          color={colorArr[4]}
          reflectivity={1}
          roughness={0.8}
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/Hands4.glb')
